import React, { useRef, useState } from 'react';
import { LuUpload, LuFileText, LuX } from 'react-icons/lu';
import useAPI from '../../../../hooks/useAPI';
import { upload_s3 } from '../../UploaderS3';
import { useNodeForm } from '../Components/NodeFormKit';
import { Field, FormSection, TextInput } from './AgentFields';

const LIMITS = [
  { test: (type) => type.startsWith('image/'), max: 5, label: 'imágenes' },
  { test: (type) => type.startsWith('video/'), max: 16, label: 'videos' },
  { test: () => true, max: 100, label: 'documentos' },
];

const FileToolConfig = ({ tool, setConfig }) => {
  const { theme, color } = useNodeForm();
  const { urlAPI_1, fetchWithAuth } = useAPI();
  const inputRef = useRef(null);
  const [uploading, setUploading] = useState(false);
  const [error, setError] = useState('');
  const conf = tool.config || {};

  const upload = async (event) => {
    const file = event.target.files?.[0];
    event.target.value = '';
    if (!file) return;
    const type = file.type || 'application/octet-stream';
    const limit = LIMITS.find((item) => item.test(type));
    if (file.size > limit.max * 1024 * 1024) {
      setError(`WhatsApp acepta ${limit.label} de hasta ${limit.max} MB.`);
      return;
    }
    setError('');
    setUploading(true);
    try {
      const response = await fetchWithAuth(`${urlAPI_1}getSignedURL/${encodeURIComponent(file.name)}/${file.size}`, { method: 'GET', mode: 'cors' });
      const signed = response.status === 200 ? await response.json() : null;
      const url = signed && !signed.error ? await upload_s3(file, signed) : null;
      if (!url) throw new Error('upload');
      setConfig({ url, name: file.name, mime: type });
    } catch (uploadError) {
      setError('No se pudo subir el archivo. Intenta de nuevo.');
    } finally {
      setUploading(false);
    }
  };

  return (
    <FormSection title="Archivo" style={{ marginBottom: '14px' }}>
      {conf.url ? (
        <div style={{ display: 'flex', alignItems: 'center', gap: '10px', padding: '10px', borderRadius: '8px', border: `1px solid ${theme.border}`, marginBottom: '12px' }}>
          <LuFileText style={{ fontSize: '18px', color: theme.textSecondary, flexShrink: 0 }} />
          <a href={conf.url} target="_blank" rel="noreferrer" style={{ flex: 1, minWidth: 0, fontSize: '12px', color: theme.textPrimary, whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}>
            {conf.name || conf.url}
          </a>
          <button type="button" aria-label="Quitar archivo" onClick={() => setConfig({ url: '', name: '', mime: '' })} style={{ border: 'none', background: 'transparent', color: theme.textSecondary, cursor: 'pointer', display: 'flex', padding: '4px' }}>
            <LuX style={{ fontSize: '14px' }} />
          </button>
        </div>
      ) : (
        <button
          type="button"
          onClick={() => inputRef.current?.click()}
          disabled={uploading}
          style={{ width: '100%', display: 'flex', alignItems: 'center', justifyContent: 'center', gap: '8px', padding: '14px', marginBottom: '12px', borderRadius: '8px', border: `1px dashed ${theme.border}`, background: 'transparent', color: theme.textPrimary, fontSize: '12px', fontWeight: 600, cursor: 'pointer' }}
        >
          <LuUpload style={{ fontSize: '15px', color }} />
          {uploading ? 'Subiendo…' : 'Subir PDF, imagen o video'}
        </button>
      )}
      <input ref={inputRef} type="file" accept=".pdf,.doc,.docx,.xls,.xlsx,.ppt,.pptx,.txt,image/jpeg,image/png,video/mp4" style={{ display: 'none' }} onChange={upload} />
      {error && <div style={{ fontSize: '12px', color: '#D93A4E', marginBottom: '10px' }}>{error}</div>}
      <Field label="Nombre que ve el contacto" hint="Solo aplica a documentos.">
        <TextInput value={conf.name} onChange={(name) => setConfig({ name })} placeholder="portafolio.pdf" />
      </Field>
      <Field label="Texto que acompaña el archivo" style={{ marginBottom: 0 }}>
        <TextInput value={conf.caption} onChange={(caption) => setConfig({ caption })} placeholder="Aquí tienes la información completa" />
      </Field>
    </FormSection>
  );
};

export default FileToolConfig;
